import { InspectButtonStatus } from "@/model/InspectButtonStatus";
import {
  JizenInspectionSelectionsRouteService,
  JizenRecommendInspectionSelectionsService
} from "@/model/JizenInspectionSelectionsRouteService";
import { INSPECT_TYPE } from "@/model/InspectType";
import {
  createBaseInspectionSelectionsRouteService
} from "@/service/InspectionSelectionsRouteService";
import requestService from "@/service/requestService";

/*
 * WHY: jizen だけカテゴリ内に通常点検とおすすめが混在するため、
 * osusume 判定を jizen 専用 service として切り出す。
 */
function createJizenRecommendInspectionSelectionsService():
  JizenRecommendInspectionSelectionsService {
  return {
    /*
     * WHY: inspectionSelections.vue から category.osusume の直接判定をなくす。
     */
    isRecommendCategory(category: any): boolean {
      return !!category && category.osusume == true;
    }
  };
}

/*
 * WHY: jizen おすすめカテゴリは子カテゴリ単位で完了判定するため、
 * 登録 status 算出前に recommend 内の status を補完する。
 */
function completeJizenRecommendStatus(categories: any[]) {
  categories.forEach((cate: any) => {
    if (cate.osusume) {
      cate.recommend.forEach((subCate: any) => {
        subCate.status = InspectButtonStatus.COMPLETED;
        subCate.subItems.forEach((item: any) => {
          if (item.osusumeIsShow == 1 && item.buhinSelected != 2) {
            subCate.status = InspectButtonStatus.INCOMPLETE;
          }
        });
      });
    }
  });
}

/*
 * WHY: jizen 固有の API、整備種別区分、登録 status、おすすめ自動処理を
 * inspectionSelections.vue の routeName 分岐から分離する。
 */
export function createJizenInspectionSelectionsRouteService(
  reqService: requestService
): JizenInspectionSelectionsRouteService {
  return createBaseInspectionSelectionsRouteService({
    routeName: "jizen",
    inspectType: INSPECT_TYPE.JIZEN,
    headerTopic: "事前見積",
    apiPath: "jizen",
    reqService,
    recommendService: createJizenRecommendInspectionSelectionsService(),
    getInspect: (
      uketsukeExtendsId: number,
      sknSeibiShubetsuKbn: string = ""
    ) => reqService.getJizenInspect(uketsukeExtendsId, sknSeibiShubetsuKbn),
    getInspectByCategoryId: (
      uketsukeExtendsId: number,
      sknInspectCategoryId: number,
      sknSeibiShubetsuKbn: string = ""
    ) =>
      reqService.getJizenInspectByCategoryId(
        uketsukeExtendsId,
        sknInspectCategoryId,
        sknSeibiShubetsuKbn
      ),
    saveInspect: (data: any) => reqService.saveJizenInspect(data),
    /*
     * WHY: jizen API だけ sknSeibiShubetsuKbn を query として使うため。
     */
    getSknSeibiShubetsuKbn(sknUketsukeExtends: any): string {
      return sknUketsukeExtends &&
        sknUketsukeExtends.sknSeibiShubetsuKbn &&
        sknUketsukeExtends.sknSeibiShubetsuKbn > 0
        ? sknUketsukeExtends.sknSeibiShubetsuKbn.toString()
        : "";
    },
    /*
     * WHY: jizen はおすすめカテゴリの status 補完後に専用登録 status を算出するため。
     */
    getRegisterStatus(categories: any[], inspectService: any): string {
      completeJizenRecommendStatus(categories);
      return inspectService.getJizenRegisterStatus(categories);
    },
    /*
     * WHY: jizen 登録時だけ uketsukeExtends 側の整備種別更新が必要なため。
     */
    shouldUpdateUketsukeExtendsOnRegister(): boolean {
      return true;
    },
    /*
     * WHY: jizen のおすすめは保存後に自動 reset する画面仕様があるため。
     */
    shouldAutoResetJizenRecommend(): boolean {
      return true;
    },
    /*
     * WHY: jizen のおすすめ自動選択は手入力ではない場合だけ行うため。
     */
    shouldAutoSetJizenRecommend(notManual: boolean): boolean {
      return !!notManual;
    },
    /*
     * WHY: jizen は保存後に socket flag を常に clear する必要があるため。
     */
    shouldClearSocketAfterInspectSave(): boolean {
      return true;
    },
    /*
     * WHY: jizen はおすすめ処理との兼ね合いで未紐づけ disabledSave をここでは除外しないため。
     */
    shouldRemoveUnlinkedDisabledSaveSeibi(): boolean {
      return false;
    }
  }) as JizenInspectionSelectionsRouteService;
}
